import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { ReportTerminFilter } from '../interfaces/ReportTermin';

type TemplateFilterReportTermin = {
    userTemplateFilterReportTermin: ReportTerminFilter[];
    setUserTemplateFilterReportTermin: (userTemplateFilterReportTermin: ReportTerminFilter[]) => void;
    companyTemplateFilterReportTermin: ReportTerminFilter[];
    setCompanyTemplateFilterReportTermin: (companyTemplateFilterReportTermin: ReportTerminFilter[]) => void;
}

export const useTemplateFilterReportTermin = create<TemplateFilterReportTermin>()(
    persist(
        (set) => ({
            userTemplateFilterReportTermin: [],
            companyTemplateFilterReportTermin: [],
            setUserTemplateFilterReportTermin: (userTemplateFilterReportTermin) => {
                set({ userTemplateFilterReportTermin });
            },
            setCompanyTemplateFilterReportTermin: (companyTemplateFilterReportTermin) => {
                set({ companyTemplateFilterReportTermin });
            },
        }),
        {
            name: 'template-filter-report-termin',
            storage: createJSONStorage(() => localStorage),
        }
    )
);
